.keyboardKeys {
  display: flex;
  gap: 0.25rem;
  align-items: center;

  kbd {
    display: flex;
    padding: 0.25rem 0.5rem;
    justify-content: center;
    align-items: center;
    gap: 0.125rem;
    border-radius: 0.25rem;
    background: var(--color-hover);
    font-family: inherit;
    height: 1.75rem;

    svg {
      width: 1rem;
      height: 1rem;
      fill: var(--color-help-text);
    }

    span {
      color: var(--color-help-text);
    }
  }
}

.keyboardKeysHintText {
  display: flex;
  align-items: center;
  gap: 1rem;
}
